import type { ComponentProps, ReactElement } from "react";
import {
  Link,
  type AnyRouter,
  type LinkComponentProps,
  type RegisteredRouter,
} from "@tanstack/react-router";

import { cn } from "@/lib/utils";

type InternalUnderlineLinkProps = ComponentProps<typeof Link> & {
  className?: string;
  external?: false;
};

type ExternalUnderlineLinkProps = ComponentProps<"a"> & {
  external: true;
};

type UnderlineLinkProps =
  | InternalUnderlineLinkProps
  | ExternalUnderlineLinkProps;

export function UnderlineLink<
  TRouter extends AnyRouter = RegisteredRouter,
  const TFrom extends string = string,
  const TTo extends string | undefined = undefined,
  const TMaskFrom extends string = TFrom,
  const TMaskTo extends string = "",
>(
  props: LinkComponentProps<"a", TRouter, TFrom, TTo, TMaskFrom, TMaskTo> & {
    external?: false;
  },
): ReactElement;
export function UnderlineLink(props: InternalUnderlineLinkProps): ReactElement;
export function UnderlineLink(props: ExternalUnderlineLinkProps): ReactElement;
export function UnderlineLink(props: UnderlineLinkProps) {
  if (props.external) {
    const { className, external: _external, ...anchorProps } = props;

    return (
      <a
        className={cn("underline-link", className)}
        target="_blank"
        rel="noopener noreferrer"
        {...anchorProps}
      />
    );
  }

  const { className, external: _external, ...linkProps } = props;

  return <Link className={cn("underline-link", className)} {...linkProps} />;
}
